<template>
  <StatCard
    title="Total Products"
    :value="formattedValue"
    icon="inventory_2"
    icon-class="product-icon"
    :trend="statsComparison.trend"
    :percentage="statsComparison.percentage"
    :comparison-period="comparisonPeriod"
  />
</template>

<script>
import StatCard from "./StatCard.vue";
import millify from "millify";

export default {
  name: "ProductsCard",
  components: {
    StatCard
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    statsComparison: {
      type: Object,
      default: () => ({ percentage: 0, trend: 'neutral' })
    },
    comparisonPeriod: {
      type: String,
      default: 'previous_period'
    }
  },
  computed: {
    formattedValue() {
      return this.value ? millify(Number(this.value)) : "0";
    }
  }
};
</script> 